export default {
  toDtos: (databaseResponses, DtoClass) => databaseResponses.map(databaseResponse => new DtoClass(databaseResponse)),
}
